import { loadStripe } from "@stripe/stripe-js";
import type { Stripe } from "@stripe/stripe-js";

/**
 * Shared Stripe.js promise — created once, lazily on first use.
 *
 * Using a getter means the <script> tag for js.stripe.com is only injected
 * the first time a payment component is actually rendered, not during the
 * initial bundle evaluation on every page (e.g. the login page).
 *
 * The `.catch(() => null)` ensures the promise never rejects:
 * if Stripe's CDN is unavailable (bots, offline, CSP, etc.) the Elements
 * provider gracefully receives null and skips rendering — instead of
 * throwing an unhandled rejection that Datadog would capture.
 */
let _stripePromise: Promise<Stripe | null> | null = null;

export function getStripePromise(): Promise<Stripe | null> {
  if (!_stripePromise) {
    _stripePromise = loadStripe(
      import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? ""
    ).catch(() => null);
  }
  return _stripePromise;
}
